
$( document ).ready(function() {
  $('.qtybox .btnqty').on('click', function(){  
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
  var vv =  $(this).val();   
  qty++;
  $(this).parents('.product-info__main').find('.quantity-input').attr("value",qty);
 
  }else {
    if(qty > 1) {
      qty--;
     $(this).parents('.product-info__main').find('.quantity-input').attr("value",qty);
    }
  }
  qty = (isNaN(qty) )?1:qty;   
  // $(this).parent('.qtybox').find('.quantity-input').attr("value" ,1);
}); 
  
  // $(".product-info__cart-btn.add").click(function (e) {
   // e.preventDefault();
   //  let quantity = $(this).parents(".product-info__main").find(".qtybox input").val();
   // let  variantID = $(this).parents(".product-info__main").find("form input").val();
   //   $(this).parents(".product-info__main").find(".qtybox .quantity-selector").attr("value" , quantity);
   //  console.log(quantity, "quantity");
   //  console.log(variantID, "variantID");
    

    // $.ajax({
    //   type: "POST",
    //   url: "/cart/add.js",
    //   data: {
    //     quantity: quantity,
    //     id: variantID,
    //   },
    //   dataType: "json",
    //   success: function (response) {
    //     console.log(response);
    //     window.location.href = "/cart";
    //   },
    //   error: function (xhr, status, error) {
    //     console.error(xhr.responseText);
    //   },
    // });
  // });


 
  
})
